import { forwardRef } from 'react';

import {
  Typography as Text,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { DateUtils } from '@spotify/confidence-core-react';

const styles = createStyles({
  root: {},
});

export interface TimestampProps extends WithStyles<typeof styles> {
  className?: string;
  timestamp: string;
}

const Timestamp = forwardRef<HTMLParagraphElement, TimestampProps>(
  (props, ref) => {
    const { className, classes, timestamp, ...rest } = props;

    return (
      <Text
        ref={ref}
        component="span"
        variant="body2"
        color="textSecondary"
        className={classNames(classes.root, className)}
        {...rest}
      >
        {DateUtils.xAgo(new Date(timestamp))}
      </Text>
    );
  },
);

Timestamp.displayName = 'ActivityFeedItem.Timestamp';

export default withStyles(styles)(Timestamp);
